import { defineStore, getActivePinia } from 'pinia'

import type { GaApp } from '~/modules/app'

import { getters } from './getters'
import { state } from './state'

export const modalsStore = (gaApp: GaApp) => {
  const init = defineStore('modals', {
    getters: getters(gaApp),
    state,
  })

  return init(getActivePinia())
}
